import signalr from 'BASE/common/signalrAdapter'
import register from 'BASE/common/chat/chat.register'

import PerfectScrollbar from 'perfect-scrollbar'
import CONSTANT from 'BASE/common/chat/chat.constant'
import UTIL from 'BASE/common/chat/chat.util'

import room_list_classification from 'BASE/components/chat/chat.base.component.roomListClassification'
import room from "BASE/components/chat/chat.base.component.room"
import room_window from 'BASE/components/chat/chat.base.component.roomWindow'

import chatKeepToken from 'BASE/common/chat/chat.keepToken';
import messageLossDetection from 'BASE/common/chat/chat.messageLossDetection';

export default {
    components: {
        room_list_classification,
        room,
        room_window,
    },
    data: function () {
        return {
            isInitiated: false,
            isShowRoomList: false,
            searchRoomText: "",
            isSearchRoomResultEmpty: false,
            searchRoomResult: [],
            dragWindow: {},
            options: {
                excludeIsChatDenied: false,
                forceInitialization: true,
            },
        }
    },
    methods: {
        openRoomList: function () {
            this.isShowRoomList = true;
        },
        closeRoomList: function () {
            this.isShowRoomList = false;
        },
        searchRoom: function () {
            this.searchRoomResult = [];
            this.isSearchRoomResultEmpty = false;
            if (this.searchRoomText !== "") {
                var text = this.searchRoomText.toLowerCase();
                this.searchRoomResult = this.$store.state.chat.rooms.filter((item) => {
                    return item.type === CONSTANT.roomType.DESCENDANT
                        && item.name.toLowerCase().indexOf(text) >= 0;
                });

                this.isSearchRoomResultEmpty =  this.searchRoomResult.length <= 0;
            }
            this.$nextTick(() => UTIL.scrollbarTop(this.$refs.searchRoomScroll));
        },
    },
    computed: {
        roomWindows: function () {
            return this.$store.state.chat.roomWindows;
        },
        systemRoom: function () {
            return this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.SYSTEM);
        },
        customerServiceRoom: function () {
            return this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.CUSTOMER_SERVICE);
        },
        ancestorRoom: function () {
            return this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.ANCESTOR);
        },
        descendantClassification: function () {
            return this.$store.state.chat.roomListClassifications.find((item) => item.roomType === CONSTANT.roomType.DESCENDANT && !item.name);
        },
        descendantCustomizedClassifications: function () {
            return this.$store.state.chat.roomListClassifications.filter((item) => item.roomType === CONSTANT.roomType.DESCENDANT && !!item.name);
        },
        groupRooms: function () {
            return this.$store.state.chat.rooms.filter((item) => item.type === CONSTANT.roomType.DESCENDANT_GROUP);
        },
        ancestorFamilyRoom: function () {
            return this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.ANCESTOR_FAMILY);
        },
        descendantFamilyRoom: function () {
            return this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.DESCENDANT_FAMILY);
        },
        siteRoom: function () {
            return this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.SITE);
        },
        systemRoomUnreadCount: function () {
            let systemRoom = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.SYSTEM);
            if(systemRoom)
                return systemRoom.unreadCount;

            return 0;
        },
        customerServiceRoomUnreadCount: function () {
            let customerServiceRoom = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.CUSTOMER_SERVICE);
            if(customerServiceRoom)
                return customerServiceRoom.unreadCount;
            
            return 0;
        },
        ancestorRoomUnreadCount: function () {
            let ancestorRoom = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.ANCESTOR);
            if(ancestorRoom)
                return ancestorRoom.unreadCount;
            
            return 0;
        },
        descendantRoomUnreadCountSum: function () {
            var sum = 0;
            this.$store.state.chat.rooms.forEach((item) => {
                if (item.type === CONSTANT.roomType.DESCENDANT) {
                    sum += item.unreadCount;
                }
            });
            return sum;
        },
        groupRoomUnreadCountSum: function () {
            var sum = 0;
            this.$store.state.chat.rooms.forEach((item) => {
                if (item.type === CONSTANT.roomType.DESCENDANT_GROUP) {
                    sum += item.unreadCount;
                }
            });
            return sum;
        },
        unreadCountSum: function () {
            var sum = 0;
            this.$store.state.chat.rooms.forEach((item) => {
                sum += item.unreadCount;
            });
            return sum;
        },
        roomSum: function () {
            return this.$store.state.chat.rooms.length;
        },
        ancestorFamilyRoomMemberCount: function () {
            return this.$store.state.chat.roomMemberContainers.find((item) => item.room.type === CONSTANT.roomType.ANCESTOR_FAMILY).roomMembers.length;
        },
        descendantFamilyRoomMemberCount: function () {
            return this.$store.state.chat.roomMemberContainers.find((item) => item.room.type === CONSTANT.roomType.DESCENDANT_FAMILY).roomMembers.length;
        },
        onTalkSystemRoom: function () {
            return this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.SYSTEM && item.onTalkTime);
        },
        onTalkCustomerServiceRoom: function () {
            return this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.CUSTOMER_SERVICE && item.onTalkTime);
        },
        onTalkAncestorRoom: function () {
            return this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.ANCESTOR && item.onTalkTime);
        },
        loginId: function() {
            return this.$store.state.chat ? this.$store.state.chat.loginId : "";
        },
        hasChatExternalLink() {
            return this.$store.state.userinfo.hasChatExternalLink;
        },
    },
    created: function () {
        register.initialize(this, () => {
            this.isInitiated = true;
            chatKeepToken.start(this);
            messageLossDetection.start(this);
        }, this.options.forceInitialization);
    },
    beforeDestroy: async function () {
        chatKeepToken.stop();
    },
    mounted: function () {
        if (this.$refs.searchRoomScroll) {
            new PerfectScrollbar(this.$refs.searchRoomScroll, {wheelPropagation: false});
        }
        this.dragWindow = this.$refs.dragWindow;
    }
};